/* TBD - partial conversion */
const dictParams: { [key: string]: any } = {};
const actions: { [key: string]: (...args: any[]) => any } = {};

// in device canvas but never used
/* istanbul ignore next */
export class Benchmark {
  param(key: string, increment?: number | string): any {
    if (typeof dictParams[key] === 'undefined') dictParams[key] = 0;

    // Without argument - return current param
    if (typeof increment === 'undefined') return dictParams[key];

    // With argument - update current param
    else if (typeof increment === 'number') dictParams[key] += increment;
    else if (typeof increment === 'string') dictParams[key] = increment;
  }

  action(key: string, args?: any[]): any {
    if (typeof args === 'function') {
      if (actions[key]) throw new Error('Action already exists: ' + key);
      actions[key] = args;
    } else {
      const action = actions[key];
      if (!action) throw new Error('Action not found: ' + key);

      const actionParams: any[] = [
        {
          param: (paramKey: string) => {
            return this.param(paramKey);
          },
        },
      ];

      if (Array.isArray(args)) actionParams.push(...args);

      return action.apply(null, actionParams);
    }
  }
}
